export const lightTheme = {
  colors: {
    primary: '#2563eb',
    primaryLight: '#60a5fa',
    primaryDark: '#1d4ed8',
    primaryHover: '#3b82f6',
    primaryDarker: '#1e40af',
    secondary: '#64748b',
    secondaryDark: '#475569',
    secondaryDarker: '#334155',
    background: '#ffffff',
    backgroundHover: '#f8fafc',
    backgroundLight: '#f1f5f9',
    backgroundAlt: '#f8fafc',
    backgroundDisabled: '#e2e8f0',
    disabledBackground: '#e2e8f0',
    inputBackground: '#f8fafc',
    surface: '#f8fafc',
    text: '#0f172a',
    textSecondary: '#475569',
    textLight: '#64748b',
    white: '#ffffff',
    border: '#e2e8f0',
    borderLight: '#f1f5f9',
    error: '#dc2626',
    errorLight: '#fecaca',
    errorDark: '#b91c1c',
    errorDarker: '#991b1b',
    success: '#16a34a',
    successLight: '#bbf7d0',
    successDark: '#15803d',
    warning: '#ca8a04',
    danger: '#dc2626',
    dangerLight: '#fecaca',
    dangerDark: '#b91c1c'
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem'
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    full: '9999px'
  },
  typography: {
    fontFamily: "'Inter', system-ui, sans-serif",
    sizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem'
    },
    weights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  }
};

export const darkTheme = {
  ...lightTheme,
  colors: {
    primary: '#3b82f6',
    primaryLight: '#60a5fa',
    primaryDark: '#1d4ed8',
    primaryHover: '#60a5fa',
    primaryDarker: '#1e40af',
    secondary: '#94a3b8',
    secondaryDark: '#64748b',
    secondaryDarker: '#475569',
    background: '#0f172a',
    backgroundHover: '#1e293b',
    backgroundLight: '#1e293b',
    backgroundAlt: '#334155',
    backgroundDisabled: '#334155',
    disabledBackground: '#334155',
    inputBackground: '#1e293b',
    surface: '#1e293b',
    text: '#f8fafc',
    textSecondary: '#cbd5e1',
    textLight: '#94a3b8',
    white: '#ffffff',
    border: '#334155',
    borderLight: '#475569',
    error: '#ef4444',
    errorLight: '#fecaca',
    errorDark: '#dc2626',
    errorDarker: '#b91c1c',
    success: '#22c55e',
    successLight: '#bbf7d0',
    successDark: '#15803d',
    warning: '#eab308',
    danger: '#ef4444',
    dangerLight: '#fecaca',
    dangerDark: '#dc2626'
  }
};

